<template>
  <div class="checkbox">
    <label>
      <input class="inputElement" type="checkbox" :id="'value-'+id" value="1" :checked="value === true">
      <span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span>
    </label>
  </div>
</template>

<script>
export default {
  name: "CheckboxInput",
  data() {
    return {
      output: {}
    };
  },
  props: ["value", "id"]
};
</script>

<style scoped>
.checkbox label:after {
  content: "";
  display: table;
  clear: both;
}

.checkbox .cr {
  position: relative;
  display: block;
  border: 1px solid #a9a9a9;
  border-radius: 0.25em;
  width: 1.3em;
  height: 1.3em;
  float: left;
  margin-right: 0.5em;
}

.checkbox .cr .cr-icon {
  position: absolute;
  font-size: 0.8em;
  line-height: 0;
  top: 50%;
  left: 15%;
}

.checkbox label {
	padding-left: 3.5px;
}

.checkbox label input[type="checkbox"] {
  display: none;
}

.checkbox label input[type="checkbox"] + .cr > .cr-icon {
  opacity: 0;
}

.checkbox label input[type="checkbox"]:checked + .cr > .cr-icon {
  opacity: 1;
}

.checkbox label input[type="checkbox"]:disabled + .cr {
  opacity: 0.5;
}
</style>


// WEBPACK FOOTER //
// src/components/input/CheckboxInput.vue